import { ReactNode } from "react";

import { Building2, Earth, Lock, Users } from "lucide-react";

import { SimpleTooltip } from "@/components/ui/tooltip";
import { SUBTEXT_COLOR } from "@/css/constants";
import { SharingStatus } from "@/graphql";

interface SharingStatusIconProps {
  sharingStatus: SharingStatus;
  showTooltip?: boolean;
  size?: number;
}

const DEFAULT_SIZE = 20;

export function SharingStatusIcon({
  sharingStatus,
  showTooltip = true,
  size = DEFAULT_SIZE,
}: SharingStatusIconProps) {
  const iconProps = {
    color: SUBTEXT_COLOR,
    size,
  };

  const sharingStatusIconMap: Record<
    SharingStatus,
    { icon: ReactNode; content: string }
  > = {
    Private: {
      icon: <Lock {...iconProps} />,
      content: "Private",
    },
    Shared: {
      icon: <Users {...iconProps} />,
      content: "Shared",
    },
    Workspace: {
      icon: <Building2 {...iconProps} />,
      content: "Workspace",
    },
    Global: {
      icon: <Earth {...iconProps} />,
      content: "Global",
    },
  };

  const { icon, content } = sharingStatusIconMap[sharingStatus] || {};

  if (!icon || !content) return null;

  return showTooltip ? (
    <SimpleTooltip content={content}>{icon}</SimpleTooltip>
  ) : (
    icon
  );
}
